import { getIsUserImpersonated } from '../../../infra/session';
var buildActions = function (subscription) {
    var canDisplayPaymentActions = subscription.canManageSubscription && !!subscription.invoiceId && !!subscription.subscriptionId;
    var actions = [];
    if (canDisplayPaymentActions) {
        actions = [
            {
                type: 'try-payment-again',
                role: 'primary',
            },
            {
                type: 'change-payment-card',
                role: 'secondary',
            },
            {
                type: 'contact-support',
                role: 'secondary',
            },
        ];
    }
    else {
        actions = [
            {
                type: 'contact-support',
                role: 'primary',
            },
        ];
    }
    if (getIsUserImpersonated()) {
        actions.push({
            type: 'admin-dismissal',
            role: 'secondary',
        });
    }
    return actions;
};
export var mapSubToViewModel = function (subscription) {
    return {
        blockAccess: subscription.blockAccess,
        title: subscription.message.title,
        body: subscription.message.body,
        icon: subscription.blockAccess ? 'error' : 'warning',
        actions: buildActions(subscription),
    };
};
